// @generated by protoc-gen-connect-es v1.6.1
// @generated from file ai/h2o/mlops/storage/v1/deployment_environment_service.proto (package ai.h2o.storage, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { CreateDeploymentEnvironmentRequest, CreateDeploymentEnvironmentResponse, DeleteDeploymentEnvironmentRequest, DeployRequest, DeployResponse, GetDeploymentEnvironmentRequest, GetDeploymentEnvironmentResponse, ListDeploymentEnvironmentsRequest, ListDeploymentEnvironmentsResponse, UpdateDeploymentEnvironmentRequest, UpdateDeploymentEnvironmentResponse } from "@buf/h2oai_mlops-storage.bufbuild_es/ai/h2o/mlops/storage/v1/deployment_environment_service_pb.js";
import { Empty, MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service ai.h2o.storage.DeploymentEnvironmentService
 */
export const DeploymentEnvironmentService = {
  typeName: "ai.h2o.storage.DeploymentEnvironmentService",
  methods: {
    /**
     * @generated from rpc ai.h2o.storage.DeploymentEnvironmentService.GetDeploymentEnvironment
     */
    getDeploymentEnvironment: {
      name: "GetDeploymentEnvironment",
      I: GetDeploymentEnvironmentRequest,
      O: GetDeploymentEnvironmentResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc ai.h2o.storage.DeploymentEnvironmentService.CreateDeploymentEnvironment
     */
    createDeploymentEnvironment: {
      name: "CreateDeploymentEnvironment",
      I: CreateDeploymentEnvironmentRequest,
      O: CreateDeploymentEnvironmentResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc ai.h2o.storage.DeploymentEnvironmentService.UpdateDeploymentEnvironment
     */
    updateDeploymentEnvironment: {
      name: "UpdateDeploymentEnvironment",
      I: UpdateDeploymentEnvironmentRequest,
      O: UpdateDeploymentEnvironmentResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc ai.h2o.storage.DeploymentEnvironmentService.DeleteDeploymentEnvironment
     */
    deleteDeploymentEnvironment: {
      name: "DeleteDeploymentEnvironment",
      I: DeleteDeploymentEnvironmentRequest,
      O: Empty,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc ai.h2o.storage.DeploymentEnvironmentService.ListDeploymentEnvironments
     */
    listDeploymentEnvironments: {
      name: "ListDeploymentEnvironments",
      I: ListDeploymentEnvironmentsRequest,
      O: ListDeploymentEnvironmentsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc ai.h2o.storage.DeploymentEnvironmentService.Deploy
     */
    deploy: {
      name: "Deploy",
      I: DeployRequest,
      O: DeployResponse,
      kind: MethodKind.Unary,
    },
  }
};

